import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type {
  DashboardOverallRequest,
  DashboardOverallResponse,
  DashboardPerScopeValueRequest,
  DashboardPerScopeValueResponse,
} from '../../domain/types';

export default ({ baseURL }: ApiConfig) => ({
  getDashboardOverall: typedMethodPost<DashboardOverallRequest, DashboardOverallResponse>(
    (data) =>
      fetch(`${baseURL}/v2/statistics/dashboard`, {
        method: 'POST',
        ...data,
      })
  ),
  getDashboardPerScopeValue: typedMethodPost<DashboardPerScopeValueRequest, DashboardPerScopeValueResponse>(
    (data) =>
      fetch(`${baseURL}/v2/statistics/dashboard`, {
        method: 'POST',
        ...data,
      })
  ),
});

export type {
  DashboardOverallRequest,
  DashboardOverallResponse,
  DashboardPerScopeValueRequest,
  DashboardPerScopeValueResponse,
} from '../../domain/types';
